var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogomarkClear(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 407.02 211.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #F7FBEC;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "12.66 211.3 0 211.3 77.57 0 90.23 0 12.66 211.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "188.84 211.3 118.28 211.3 195.85 0 266.42 0 188.84 211.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90.23,
    y: 0,
    width: 28.05,
    height: 211.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 266.42,
    y: 0,
    width: 140.61,
    height: 211.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomarkClear);
export default __webpack_public_path__ + "static/media/logomark-clear.64af9f9b6c86f392ce0b7f24d240c088.svg";
export { ForwardRef as ReactComponent };